import type { FaireThemeEntity } from "../../entity_types/theme";

export const sweet_and_cozy_baby_accents: FaireThemeEntity = {
  token: "sweet-and-cozy-baby-accents",
  type: "theme",
  name: "Sweet & Cozy Baby Accents",
  description: "Adorable soft-knit accessories to keep little ones warm during cooler months.",
  teaser: "Soft-knit baby accessories that pair with your gowns and kids' apparel.",
  detail: "Your established customer base for baby gowns, pacifiers, and kids' items makes this a natural add. The recent Baby's Pom Pom Knitted Hat in your cart confirms continued interest in children's accessories.",
  bgColor: "#EDE0F5",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_2asezecnvg",
    "p_7cxnaz9c3m",
    "p_1aexb578km",
    "p_yqpd4fnyac",
    "p_u4mfrqc8ac",
    "p_4w7a6pw4dz",
    "p_42n546c9et",
    "p_77pzm6hwqy",
    "p_uvxxe6zxjz",
    "p_ttwxumbcww",
    "p_5gk3gysqy6",
    "p_34xyv6zu5q",
    "p_pqxuhvg9na",
    "p_aumvsh43nf",
    "p_384mz79hu4",
    "p_8mwhyjnhi9",
    "p_yswfr8nque",
    "p_xh3jhjv7rz",
    "p_m2ats3qwmc",
    "p_xxpbgurgas",
    "p_mh5ctvspga",
    "p_ja4env94bz",
    "p_5ev5e97mm6",
    "p_rccs8zrjcx",
    "p_6nt3g6dzvf",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
